(function () {
    // "use strict" <-- basically, we should enable this option always as a best practice, but because of (such as LOC:390)
    //Service code here
    //Get the formApp module
    angular.module('formApp')
        //Register this service with the formApp module
        .factory('UtilityServices', ['$http', '$log', '$location', '$filter', '$uibModal', '$timeout', '$interpolate', '$rootScope', 'DataServices', 'Constants', '$q', 'adalAuthenticationService',

            // all the utility function in the project are resided in this service so that we can reuse them any where in the project
            function ($http, $log, $location, $filter, $uibModal, $timeout, $interpolate, $rootScope, DataServices, Constants, $q, adalAuthenticationService) {

                var utility = {};

                utility.featureNotImplemented = function () {
                    alert('Feature not implemented yet');
                    throw new Error('Feature not implemented yet');
                };

                //Sets visibility of an element. True = visible, False = hidden. Using Jquery here to support IE9.
                utility.toggleClass = function (target, remove, className) {
                    if (target) {
                        if (remove) {
                            target.removeClass(className);
                        } else {
                            target.addClass(className);
                        }
                    }
                }

                utility.setElementVisibility = function (id, show) {
                    utility.toggleClass($('#' + id), show, 'hidden');
                };

                utility.hideMenu = function () {
                    utility.setElementVisibility('manageFeedbacks', false);
                    utility.setElementVisibility('manageComplaints', false);
                    utility.setElementVisibility('tools', false);
                    utility.setElementVisibility('fmsAdminSite', false);
                };

                utility.setMenuVisibility = function () {
                    if (DataServices.isAuthenticated()) {
                        DataServices.getUserProfileInfoUsingCache()
                            .then(function (userInfo) {
                                var isPrivacyUser = DataServices.isRegisteredPrivacyUser(userInfo.roles);
                                var isComplaintsUser = DataServices.isRegisteredComplaintsUser(userInfo.roles);
                                var isAdminUser = DataServices.isRegisteredFmsAdminUser(userInfo.roles);

                                utility.setElementVisibility('manageFeedbacks', isPrivacyUser);
                                utility.setElementVisibility('manageComplaints', isComplaintsUser);
                                utility.setElementVisibility('tools', isPrivacyUser || isComplaintsUser);
                                utility.setElementVisibility('fmsAdminSite', isAdminUser);
                            }, function (data) {
                                utility.hideMenu();
                            });
                    }
                    else {
                        utility.hideMenu();
                    }
                };

                //Sets visibility of an element. True = visible, False = hidden. Using Jquery here to support IE9.

                utility.handleSessionTimeOut = function () {
                    utility.openPopup('sessionTimeout').result.then(function () {
                        sessionStorage.clear();
                        adalAuthenticationService.login();
                    });
                };

                utility.showNotification = function (visible, notifcationCode, params, returnAsPromise) {
                    var deferred = $q.defer();

                    var notification = $filter('filter')(DataServices.configData.notifications, { code: notifcationCode }, true);
                    //If notification message is not found, searching in angular constants 
                    if (notification === undefined || notification === null || notification.length == 0) {
                        if (Constants.Notification[notifcationCode] !== null && Constants.Notification[notifcationCode] !== undefined) {
                            notification = new Array();
                            notification.push(Constants.Notification[notifcationCode]);
                        }
                    }

                    if (notification && notification[0]) {
                        var notifyType = null;
                        if (notification[0].type === 'error') {
                            notifyType = Constants.NotifyType.error;
                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }

                        if (notification[0].type === 'notification') {
                            notifyType = Constants.NotifyType.notification;
                        }
                        var message = null;
                        if (params) {
                            message = $interpolate(notification[0].message)(params);
                        } else {
                            message = notification[0].message;
                        }
                        if (notifyType && message) {
                            var target = $('#notify');
                            if (target) {
                                if (visible) {
                                    target.find('span').removeClass().addClass(notifyType.css).find(':nth-child(1)').attr('xlink:href', notifyType.icon).next().html(message);
                                    target.removeClass('hidden');
                                } else {
                                    target.addClass('hidden');
                                }
                            }
                        }
                    }

                    if (returnAsPromise) {
                        return deferred.promise;
                    }
                };

                // Sets the tags necessary to indicate a question is in error. Using Jquery here to support IE9.
                utility.setQuestionErrorState = function (id, status) {
                    var input = $('#' + id);
                    var input2;
                    var input3;
                    if ($('#' + id + '-month')) {
                        input2 = $('#' + id + '-month');
                        input3 = $('#' + id + '-year');
                    }
                    var fieldset = $('#' + id + '-fieldset');
                    if (input && fieldset) {
                        if (status === true) {
                            fieldset.addClass('has-error');
                            input.attr('aria-invalid', status);
                            input.attr('aria-describedby', id + '-error');
                            if (input2 && input3) {
                                input2.attr('aria-invalid', status);
                                input2.attr('aria-describedby', id + '-error');
                                input3.attr('aria-invalid', status);
                                input3.attr('aria-describedby', id + '-error');
                            }
                        }
                        else {
                            fieldset.removeClass('has-error');
                            var describeByValue = input.attr('data-describeBy');
                            if (describeByValue)
                                input.attr('aria-describedby', describeByValue);
                            input.removeAttr('aria-invalid');
                            if (input2 && input3) {
                                input2.removeAttr('aria-describedby');
                                input2.removeAttr('aria-invalid');
                                input3.removeAttr('aria-describedby');
                                input3.removeAttr('aria-invalid');
                            }
                        }
                    }
                }

                //Returns the option set text for the response, using the response code
                utility.getOptionSetText = function (optionSet, responseCode) {
                    if (!optionSet || optionSet.length == 0 || !responseCode || responseCode.length == 0) {
                        return '';
                    }
                    var value = ($filter('filter')(DataServices.configData.optionSets[optionSet], { 'code': responseCode }, true));
                    if (!value || value.length == 0) {
                        return '';
                    }
                    return value[0].text;
                }

                //Returns the option set data for the response, using the response code
                utility.getOptionSetData = function (optionSet, responseCode) {
                    if (!optionSet || optionSet.length == 0 || !responseCode || responseCode.length == 0) {
                        return '';
                    }
                    var value = ($filter('filter')(DataServices.configData.optionSets[optionSet], { 'code': responseCode }, true));
                    if (!value || value.length == 0) {
                        return '';
                    }
                    return value[0].data;
                }

                utility.setAriaDescribedByAttribute = function (controlType, id) {
                    var attrValue = null;
                    if (controlType == 'address')
                        attrValue = 'addressAutoComplete';
                    if (controlType == 'typeahead')
                        attrValue = 'typeAheadAutoComplete';
                    if (attrValue)
                        $('#' + id).attr('aria-describedby', attrValue);
                }

                //Gets the actual value entered by the user for the particular question (not just the code from the response)
                utility.getAnswer = function (question, response) {
                    // As the response could be an array, we need to check length as well
                    if (!response || ($.isArray(response) && response.length == 0)) {
                        return null;
                    }

                    switch (question.controlType) {
                        case "text":
                        case "textarea":
                        case "address":
                            return response;
                            break;
                        case "singleCheckbox":
                            if (response) {
                                if (response == true) {
                                    return 'Yes';
                                }
                                else {
                                    return 'No';
                                }
                            }
                            return null;
                            break;
                        case "radio":
                        case "select":
                            if ((typeof question.options) === "string") {
                                return ($filter('filter')(DataServices.configData.optionSets[question.options], { 'code': response }))[0].text;
                            }
                            else {
                                return ($filter('filter')(question.options, { 'code': response }))[0].text;
                            }
                            break;
                        case "date":
                            return $filter('date')(response, 'dd/MM/yyyy');
                            break;
                        case "checkbox":
                            // this is a multi select, so we return an array of answers
                            var output = [];
                            for (var i = 0; i < response.length; i++) {
                                if ((typeof question.options) === "string") {
                                    output.push(($filter('filter')(DataServices.configData.optionSets[question.options], { 'code': response[i] }))[0].text);
                                }
                                else {
                                    output.push(($filter('filter')(question.options, { 'code': response[i] }))[0].text);
                                }
                            }
                            return output;
                            break;
                        case "typeahead":
                            return response.text;
                        default:
                            return null;
                            break;
                    }
                }

                //Returns the age as an integer by comparing the incoming date with todays date.
                utility.getAge = function (birthYear, birthMonth, birthDay) {
                    curDate = new moment();
                    curYear = curDate.year();
                    curMonth = curDate.month();
                    curDay = curDate.date();

                    age = curYear - birthYear;

                    if (curMonth < (birthMonth - 1)) {
                        age--;
                    }

                    if ((birthMonth - 1) == curMonth && curDay < birthDay) {
                        age--;
                    }
                    return age;
                }

                // Return the System Date
                utility.getSystemDate = function (format) {
                    if (!format) {
                        format = 'YYYY-MM-DD';
                    }
                    return moment(new Date()).format(format);
                }

                // Returns the minimum date (typically 01-01-1900)
                utility.getMinimumDate = function () {
                    var minDate = moment(Constants.minimumDate).format('YYYY-MM-DD');
                    return minDate;
                }

                // Returns true if the age is greater than or equal to 18 and false if age is less than 18
                utility.isAdult = function (year, month, day) {
                    if (this.getAge(year, month, day) >= 18) {
                        return true;
                    }
                    return false;
                }

                // Returns the page title
                utility.getPageTitle = function (navTabNum, pageUrl) {
                    var title = '';
                    if (navTabNum && pageUrl) {
                        var tabIncludedInProgress = _.find(DataServices.configData.navigationTabs, function (o) { return o.number == navTabNum && o.includeInProgress == true; });
                        if (tabIncludedInProgress) {
                            title = tabIncludedInProgress.title + ' tab and ' + _.find(_.find(DataServices.configData.navigationTabs, function (o) { return o.number == navTabNum; }).pages, function (p) { return p.url == pageUrl; }).docTitle + ' page';
                        } else {
                            title = _.find(_.find(DataServices.configData.navigationTabs, function (o) { return o.number == navTabNum; }).pages, function (p) { return p.url == pageUrl; }).docTitle;
                        }

                    }
                    return title;
                }

                //Opens a modal popup. The popupCode determines the content to display and must match a code in the JSON.
                utility.openPopup = function (popupCode, popupParams) {
                    return $uibModal.open({
                        animation: false,
                        backdrop: 'static',
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'app/partials/core/modalPopup.html',
                        controller: 'modalPopupController',
                        windowTemplateUrl: 'app/partials/core/modalPopupWindow.html',
                        resolve: {
                            popupCode: function () {
                                return popupCode;
                            },
                            popupParams: function () {
                                return popupParams;
                            }
                        }
                    });
                }

                // Sets focus to the supplied element id
                utility.focus = function (id) {
                    // delay is here to give old browsers time to traverse dom
                    $timeout(function () {
                        var element = id ? document.getElementById(id) : null;
                        if (element) {
                            element.focus();
                        }
                    }, 100);
                };

                // Returns true if supplied email address is a valid email address format
                utility.matchEmailRegx = function (email) {
                    var regx = /(?:[\w'"!#$%&*+/=?^_`{|}~-]+(?:\.[\w'"!#$%&*^"\\+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9]){?|}|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
                    var match = email.match(regx);
                    if (match && match.length > 0) {
                        return (email === match[0]);
                    }

                    return false;
                };

                // Removes errors from the validationErrors array without creating a new copy of the array.
                utility.removeFromValidationErrors = function (level, pageId, pageIndex, sectionCode, sectionIndex, questionCode) {
                    var toRemove = [];
                    for (var i = 0; i < DataServices.validationErrors.length; i++) {
                        if ((!level || DataServices.validationErrors[i].level == level) &&
                            (!pageId || DataServices.validationErrors[i].pageNo == pageId) &&
                            (!pageIndex || DataServices.validationErrors[i].pageIndex == pageIndex) &&
                            (!sectionCode || DataServices.validationErrors[i].sectionCode == sectionCode) &&
                            (!sectionIndex || DataServices.validationErrors[i].sectionIndex == sectionIndex) &&
                            (!questionCode || DataServices.validationErrors[i].questionCode == questionCode)) {
                            toRemove.push(i);
                        }
                    }
                    // iterate in reverse so we splice from the end of the array and don't mess up the order
                    for (var i = toRemove.length; i > 0; i--) {
                        DataServices.validationErrors.splice(toRemove[i - 1], 1);
                    }
                }

                //Checks if we have a valid, non-null response with a JSON object with more than one property (our expected response contains properties like 1-1, 1-2 etc
                utility.isValidResponse = function (response) {
                    var isValid = false;
                    var propCount = 0;
                    if (response && typeof response === 'object') {
                        for (var prop in response) {
                            if (response.hasOwnProperty(prop)) propCount++;
                        }

                        isValid = propCount > 1;
                    }
                    return isValid;
                };

                //Returns option set from configuration data
                utility.getOptionSetFromConfiguration = function (optionsetName, template) {
                    var optionSet;
                    if (!template && optionsetName) {
                        if (DataServices.configData) {
                            optionSet = DataServices.configData.optionSets[optionsetName];
                        }
                        return optionSet;
                    }

                    if (!DataServices.configData[template]) {
                        return DataServices.getConfigurationUsingCache(template, null, null, DataServices.isAuthenticated())
                            .then(function (data) {
                                return data.configData.optionSets[optionsetName];
                            });
                    }
                    else {
                        if (template && DataServices.configData[template]) {
                            optionSet = DataServices.configData[template].optionSets[optionsetName];
                        } else {
                            if (DataServices.configData) {
                                optionSet = DataServices.configData.optionSets[optionsetName];
                            }
                        }
                    }

                    return Promise.resolve(optionSet);
                };

                // Create an object from an optionSet, which can be used to convert the "code" into the "text"
                utility.getOptionSetDecodeMap = function (optionSet) {
                    var decodeMap = {};
                    for (var i = 0; i < (optionSet && optionSet.length) || 0; i++) {
                        var item = optionSet[i];
                        decodeMap[item.code] = item.text;
                    }
                    return decodeMap;
                };

                // Sets the current incident as editable or not
                utility.setCurrentIncidentAsEditable = function (isEditable) {
                    DataServices.isIncidentEditable = !!isEditable;
                }

                // Returns if the current incident is editable or not
                utility.isCurrentIncidentEditable = function () {
                    return !!DataServices.isIncidentEditable;
                }

                utility.setCurrentIncidentCanSaveFile = function (isEditable) {
                    DataServices.canSaveFileToCurrentIncident = isEditable;
                }

                // Returns if the current incident is editable or not
                utility.canSaveFileToCurrentIncident = function () {
                    return DataServices.canSaveFileToCurrentIncident;
                }

                // Checks if the user is authenticated
                utility.isAuthenticated = function () {
                    return DataServices.isAuthenticated();
                };

                utility.formateDate = function (date) {
                    return $filter('date')(date, 'dd/MM/yyyy');
                };

                utility.toggleLoadingSpinner = function (show) {
                    if (show) {
                        $('#pageLoad').addClass('loading-data');
                        $('#main_content').addClass('data-container');
                    }
                    else {
                        $('#pageLoad').removeClass('loading-data');
                        $('#main_content').removeClass('data-container');
                    }
                };

                utility.invalidUserLogout = function () {
                    utility.openPopup('invalidUser')
                        .result.then({}, function () {
                            $location.path('/logout');
                        });
                };

                return utility;
            }

        ]);

}());